function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import appApis from '@/services/profiling';
import utils from '@/js/utils';
import tasks from '@/js/tasks';
import ProfilingScoreService from '@/apps/data-platform/services/data_quality/profiling_score_service';
export var crudProfilingScore = {
  data: function data() {
    return {
      MODAL_PROFILING_VALIDATION_TYPE: '/validation_type',
      MODAL_SCORE_FIELD_TYPE: '/profiling_score/field_type',
      MODAL_SCORE_TABLE_RULE: '/profiling_score/table_rule',
      isBusy: false,
      busy: false,
      busy2: false,
      isBusyDetail: false,
      processing: false,
      mode: '',
      record: Object,
      record_original: Object,
      overlay_message: '',
      recordSelected: null,
      items: [],
      dismissCountDown: 0,
      dismissSecs: 5,
      dangerMessage: '',
      perPage: 10,
      currentPage: 1
    };
  },
  computed: {
    readonly: function readonly() {
      return this.mode === 'view';
    },
    editonly: function editonly() {
      return this.mode === 'edit';
    },
    showMonitoringInput: function showMonitoringInput() {
      return this.mode !== 'create';
    },
    modalTitle: function modalTitle() {
      var mode = this.mode.charAt(0).toUpperCase() + this.mode.slice(1);
      var modalName = this.modalName;
      var aux = "crud." + mode;
      var modename = this.traductor(aux);
      return "".concat(modename, " ").concat(modalName);
    }
  },
  created: function created() {
    this.getRecords();
  },
  methods: {
    getRecords: function getRecords() {},
    putRecord: function putRecord() {
      var _this = this;
      var _this$getValuesToUpda = this.getValuesToUpdate(this.record, this.record_original),
        toSave = _this$getValuesToUpda.toSave,
        oldValues = _this$getValuesToUpda.oldValues;
      if (!Object.keys(toSave).length) {
        return new Promise(function (resolve, reject) {
          resolve();
          return false;
        });
      }
      return ProfilingScoreService.putScoreParam(this.modalId, this.record.document_id, this.record, oldValues).then(function (response) {
        if (!response.data.success) {
          tasks.toast.success('Editado correctamente');
          _this.dismissCountDown = _this.dismissSecs;
          _this.dangerMessage = response.data.message;
          return false;
        } else {
          return true;
        }
      });
    },
    postRecord: function postRecord() {
      var _this2 = this;
      return ProfilingScoreService.postScoreParam(this.modalId, this.record).then(function (response) {
        console.log(response);
        if (!response.data.success) {
          tasks.toast.success('Creado correctamente');
          _this2.dismissCountDown = _this2.dismissSecs;
          _this2.dangerMessage = response.data.message;
          return false;
        } else {
          return true;
        }
      });
    },
    getValuesToUpdate: function getValuesToUpdate(record, record_original) {
      var toSave = Object.keys(record).reduce(function (diff, key) {
        if (record[key] === record_original[key]) return diff;
        return _objectSpread(_objectSpread({}, diff), {}, _defineProperty({}, key, record[key]));
      }, {});
      var keys = Object.keys(toSave);
      var oldValues = {};
      for (var _i = 0, _keys = keys; _i < _keys.length; _i++) {
        var key = _keys[_i];
        if (key === 'load_date') continue;
        oldValues[key] = record_original[key];
      }
      toSave.record_id = record_original.record_id;
      return {
        toSave: toSave,
        oldValues: oldValues
      };
    },
    showModal: function showModal(data, mode) {
      if (data) {
        this.recordSelected = data.index;
        this.record = utils.cloneJSON(data.item);
        this.record_original = utils.cloneJSON(data.item);
      } else {
        this.record = {};
      }
      this.mode = mode;
      this.$refs[this.modalId].onOpen();
      // this.$root.$emit('bv::show::modal', this.modalId, '#btnShow')
    },
    handleOk: function handleOk() {
      var _this3 = this;
      if (!this.deleteValidationType) {
        return ProfilingScoreService.putScoreParam(this.modalId, this.record.document_id, this.record, this.record).then(function (response) {
          if (!response.data.success) {
            tasks.toast.success('Creado correctamente');
            _this3.dismissCountDown = _this3.dismissSecs;
            _this3.dangerMessage = response.data.message;
            return false;
          } else {
            return true;
          }
        });
      } else if (this.mode === 'create') {
        return this.postRecord();
      } else if (this.mode === 'edit') {
        return this.putRecord();
      }
    },
    handleSubmit: function handleSubmit() {
      var _this4 = this;
      if (!this.checkFormValidity()) {
        return;
      }
      this.$nextTick(function () {
        _this4.handleOk().finally(function () {
          _this4.busy2 = !_this4.busy2;
          _this4.$store.dispatch(_this4.dispatchName, _this4.modalId).then(function () {
            _this4.busy2 = !_this4.busy2;
            _this4.$refs[_this4.modalId].onClose();
          });
        });
      });
    },
    toggleBusy: function toggleBusy() {
      this.isBusy = !this.isBusy;
    },
    checkFormValidity: function checkFormValidity() {
      var valid = this.$refs.form.validate();
      return valid;
    },
    resetModal: function resetModal() {
      this.$refs[this.modalId].onClose();
    },
    onDelete: function onDelete(record) {
      this.record = record;
      this.$refs['dialogConfirmation'].onOpen();
    },
    onCancelDelete: function onCancelDelete() {
      this.busy = false;
    },
    onConfirmDelete: function onConfirmDelete(event) {
      var _this5 = this;
      if (!event) {
        this.$refs['dialogConfirmation'].onClose();
        return;
      }
      //this.processing = true
      //this.overlay_message = 'Deleting'
      var document_id = this.record.document_id;
      var request = {};
      if (!this.deleteValidationType) {
        this.record.weight = 0;
        request = ProfilingScoreService.putScoreParam(this.modalId, this.record.document_id, this.record, this.record);
      } else {
        request = ProfilingScoreService.deleteScoreParam(this.modalId, this.record.document_id, window.userInfo.domain);
      }
      request.then(function (response) {
        _this5.$store.dispatch(_this5.dispatchName, _this5.modalId).then(function () {
          _this5.$refs['dialogConfirmation'].onClose();
          tasks.toast.success('Eliminado correctamente');
        });
      });
    },
    countDownChanged: function countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    getDeletedValidationType: function getDeletedValidationType() {
      var _this6 = this;
      appApis.getRecords(this.modalId, false, 'deleted').then(function (response) {
        _this6.deleted_validation_types = response['data'];
        _this6.v_type_selected = _this6.deleted_validation_types[0].name;
      });
    }
  }
};